export const isAppInPDFMode = (): boolean => {
    return typeof window !== "undefined" && new URLSearchParams(window.location.search).get("__pdf") === "1";
};

export const resolvePreviewSlug = (params: URLSearchParams): string | null => {
    if (params.get("__pdf") !== "1") return null;

    return params.get("preview_slug")?.trim() || null;
};

export default isAppInPDFMode;
